import React, {useState, useEffect, useRef} from "react";
// External dependencies
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { IoIosMore } from "react-icons/io";
import axios from "axios";
// Internal Dependencies
import initialState from "../../data/objects/headerObject";
import Constant from "../../Constant/Constant";
import { useKeyboardShortcuts } from "../../hooks/useKeyboardShortcuts";
import { handleDropdownClick } from "../../utils/functions/handleDropdownClick";
import { v2ReactURL } from "../../utils/constant";
import { CommonFunctions } from "../../pages/PageImports";

// CSS Files
import "./header.css";
// Components
import ShortcutKeyBar from "./shortcutKeyBar/ShortcutKeyBar";
import UserMenuDropDown from "./userMenuDropDown/UserMenuDropDown";
import HeaderSearchBar from "./headerSearchbar/HeaderSearchBar";
import NotificationDropDown from "./notificationDropDown/NotificationDropDown";
import QuickLinksMenu from "./quickLinksMenu/QuickLinksMenu";
// Logos and Assets
import supportIcon from "../../assets/images/main/customer-service.png";
import LogoLink from "./logoLink/LogoLink";
import useSessionData from "../../hooks/useSessionData";
const { axiosFunction } =
  CommonFunctions;
import customerCallIcon from "../../assets/images/main/customer-call.svg";
import phoneCallIcon from "../../assets/images/main/phone-call.svg";
import envelopeIcon from "../../assets/images/main/envelope.svg";
import calenderClockIcon from "../../assets/images/main/calendar-clock.svg";
import SupportRequestModal from "../../components/modals/SupportRequestModal.tsx";
import {DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";

const Header = ({
  isToggle,
  setIsToggle,
  toggleQuickLinkMenu,
  setToggleQuickLinkMenu,
  setnavActive,
  navActive,
}) => {
  const sessionList = useSelector((state) => state.sessionData.sessionScope);

  const [toggleTopBar, setToggleTopBar] = useState(false);
  const [dropdownState, setDropdownState] = useState(initialState);
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const [notificationCount, setnotificationCount] = useState("");

  useEffect(() => {
    useKeyboardShortcuts(setDropdownState, dropdownState);
  }, []);
  useEffect(() => {
    axios
      .get("/notification/count")
      .then((response) => {
        if (typeof response.data === "number") {
          setnotificationCount(response.data);
        }
      })
      .catch((error) =>
        console.error("Error fetching navigation content:", error)
      );
  }, []);

  async function FinancialYearSelector(yearInterval) {
    try {
      await axiosFunction(
        `${v2ReactURL}/financialyear/year/set/${yearInterval}`,
        "POST",
        {
          financialYear: sessionList?.financialYear,
        }
      ).then(async (response) => {
          const res = await axios.get(`${v2ReactURL}/logout`);
          if (res?.data?.status) {
            window.location.href = "/login?logout";
            return;
          }
        });
    } catch (error) {
      console.error("Error setting financial year:", error);
    }
  }
const hideShowNavToggle = () => {
  setIsToggle(!isToggle);
  setToggleTopBar(false);

  const mainWrap = document.getElementsByClassName("m-grid__item--fluid")[0];

  if (mainWrap) {
    if (isToggle) {
      mainWrap.classList.remove("mainWrapShow");
      document.body.classList.add("m-topbar--on");
    } else {
      mainWrap.classList.add("mainWrapShow");
      document.body.classList.remove("m-topbar--on");
    }
  } else {
    console.warn("Element .m-grid__item--fluid not found in DOM");
  }

  setnavActive(!navActive);
};


  const toggleRef = useRef(null);

  const closeDropdown = () => {
    if (toggleRef.current) {
      toggleRef.current.click();
    }
  };

  return (
    <>
      <header
        id="m_header"
        className="m-grid__item m-header"
        m-minimize-offset="200"
        m-minimize-mobile-offset="200"
      >
        <div className="m-container m-container--fluid m-container--full-height">
          <div className="m-stack m-stack--ver m-stack--desktop">
            <div
              className={`m-stack__item m-brand  m-brand--skin-dark ${
                isToggle ? "m-brand-hide" : "m-brand-show"
              }`}
            >
              <div className="m-stack m-stack--ver m-stack--general">
                <LogoLink isToggle={isToggle} />
                <div className="m-stack__item m-stack__item--middle m-brand__tools">
                  <a
                    href="#"
                    id="m_aside_left_minimize_toggle"
                    onClick={() => hideShowNavToggle()}
                    className="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block  "
                  >
                    <span></span>
                  </a>
                  <a
                    href="#"
                    onClick={() => hideShowNavToggle()}
                    id="m_aside_left_offcanvas_toggle"
                    className="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block"
                  >
                    <span></span>
                  </a>
                  <a
                    id="m_aside_header_menu_mobile_toggle"
                    href="#"
                    onClick={() => {
                      setToggleQuickLinkMenu(!toggleQuickLinkMenu);
                      setToggleTopBar(false);
                      setIsToggle(false);
                    }}
                    className="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block"
                  >
                    <span></span>
                  </a>
                  <a
                    id="m_aside_header_topbar_mobile_toggle"
                    href="#"
                    onClick={() => {
                      setToggleTopBar(!toggleTopBar);
                      // setnavActive(false);
                      setIsToggle(false);
                    }}
                    className="m-brand__icon m--visible-tablet-and-mobile-inline-block"
                  >
                    <IoIosMore className="flaticon-more" />
                    {/* <i className="flaticon-more"></i> */}
                  </a>
                </div>
              </div>
            </div>

            <div
              className="m-stack__item m-stack__item--fluid m-header-head"
              id="m_header_nav"
            >
              <button
                className="m-aside-header-menu-mobile-close  m-aside-header-menu-mobile-close--skin-dark"
                id="m_aside_header_menu_mobile_close_btn"
              >
                <i className="la la-close"></i>
              </button>
              <div
                id="m_header_menu"
                className={`m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-dark m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-dark m-aside-header-menu-mobile--submenu-skin-dark ${
                  toggleQuickLinkMenu ? "m-aside-header-menu-mobile--on" : ""
                }`}
              >
                <ul className="m-menu__nav">
                  <QuickLinksMenu
                    handleDropdownClick={() =>
                      handleDropdownClick("isOpen", setDropdownState)
                    }
                    toggleQuickLinkMenu={toggleQuickLinkMenu}
                    setDropdownState={setDropdownState}
                    isOpen={dropdownState.isOpen}
                  />
                </ul>
              </div>

              <div
                id="m_header_topbar"
                className={`m-topbar m-stack m-stack--ver m-stack--general ${
                  toggleTopBar ? "showTopbar" : "hideTopbar"
                }`}
              >
                <div className="m-stack__item m-topbar__nav-wrapper">
                  <ul className="m-topbar__nav m-nav m-nav--inline">
                    <UncontrolledDropdown style={{ display: "inline" }}>
                      <DropdownToggle
                          tag="a"
                          innerRef={toggleRef}
                          onClick={(e) => {}}
                          className="btn btn-trigger action-btn dropdown-toggle btn-icon"
                      >
                        <img
                            src={customerCallIcon}
                            style={{ height: '20px' }}
                            className="support-icon"
                            alt="Customer Support"
                        />
                      </DropdownToggle>

                      <DropdownMenu style={{ minWidth: "8rem" }}>
                        <div
                            id="supportDropDown"
                            style={{
                              zIndex: 1000,
                              width: '260px',
                              padding: '10px',
                              backgroundColor: '#F5F5F5'
                            }}
                        >
                          <ul className="m-nav position-relative callList">
                            <button
                                type="button"
                                className="position-absolute"
                                style={{
                                  top: '-10px',
                                  right: '-10px',
                                  background: 'transparent',
                                  border: 'none',
                                  zIndex: 9999
                                }}
                                onClick={closeDropdown}
                            >
                              <i className="fa fa-close" style={{ fontSize: '16px', color: '#000' }}></i>
                            </button>

                            <li className="mb-3 pb-3 border-bottom d-flex align-items-center" style={{ fontSize: '14px' }}>
                              <img src={phoneCallIcon} alt="Phone" style={{ height: '16px', width: '16px' }} className="me-3" />
                              <span className="ml-2">{import.meta.env.VITE_VASY_SUPPORT_CONTACT}</span>
                            </li>

                            <li className="mb-3 pb-3 border-bottom d-flex align-items-center" style={{ fontSize: '14px' }}>
                              <img src={envelopeIcon} alt="Email" style={{ height: '16px', width: '16px' }} className="me-3" />
                              <span className="ml-2">support@vasyerp.com</span>
                            </li>

                            <li className="mb-3 pb-3 d-flex align-items-center" style={{ fontSize: '14px' }}>
                              <img src={calenderClockIcon} alt="Time" style={{ height: '16px', width: '16px' }} className="me-3" />
                              <span className="ml-2">9:00 AM - 9:00 PM (IST)</span>
                            </li>

                            <li>
                              <button
                                  className="btn m--bg-brand text-white w-100"
                                  onClick={() => {
                                    closeDropdown();
                                    setIsSupportModalOpen(true);
                                  }}
                                  style={{
                                    backgroundColor: '#0094d6',
                                    borderColor: '#0094d6',
                                    fontSize: '1rem'
                                  }}
                              >
                                Request A Callback
                              </button>
                            </li>
                          </ul>
                        </div>
                      </DropdownMenu>
                    </UncontrolledDropdown>

                    <li id="m_quick_sidebar_toggle" className="m-nav__item">
                      <HeaderSearchBar
                        isHeaderSearch={dropdownState.isHeaderSearch}
                        setDropdownState={setDropdownState}
                      />
                    </li>
                    <li
                      id="m_quick_sidebar_toggle "
                      className={`m-nav__item  dropdown-toggle dropdown ${
                        dropdownState.isNotification ? "show" : "hide"
                      }`}
                      href="#"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <NotificationDropDown
                        notificationCount={notificationCount}
                        setDropdownState={setDropdownState}
                        isNotification={dropdownState.isNotification}
                      />
                    </li>
                    {/* <c:forEach items="${sessionScope.NavMenuPermission}" var="NavMenuPermission">
                                    <c:if test="${NavMenuPermission.navMenuId==9}"> */}
                    <li className="m-nav__item m-topbar__user-profile  m-dropdown m-dropdown--medium m-dropdown--arrow  m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light">
                      <a
                        href="/pos/new"
                        className="m-nav__link m-dropdown__toggle"
                        id="newPos"
                        title="POS"
                      >
                        <span className="m-nav__link-icon">
                          <i className="fa fa-fax"></i>
                        </span>
                      </a>
                    </li>
                    {/* </c:if>
                                </c:forEach> */}
                    {dropdownState.isFinanceVo && (
                      <div
                        className="header-overlay"
                        onClick={() =>
                          handleDropdownClick("", setDropdownState)
                        }
                        onContextMenu={() =>
                          handleDropdownClick("", setDropdownState)
                        }
                      ></div>
                    )}
                    <li
                      className={`financial-year-dash m-portlet__nav-item m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push ${
                        dropdownState.isFinanceVo && "m-dropdown--open"
                      }`}
                      m-dropdown-toggle="click"
                      data-skin="light"
                      data-toggle="m-tooltip"
                      data-placement="left"
                      onClick={() =>
                        handleDropdownClick("isFinanceVo", setDropdownState)
                      }
                      data-html="true"
                      title="Financial Year"
                      aria-expanded="true"
                    >
                      <div className="m-portlet__nav-link m-dropdown__toggle dropdown-toggle btn btn-sm m-btn btn-outline-light m-btn--hover-light bg-light text-dark">
                        {/* ${sessionScope.financialYear} */}
                        {sessionList?.financialYear}
                      </div>
                      {/* {dropdownState.isFinanceVo && (
                        <div
                          className="header-overlay"
                          onClick={() =>
                            handleDropdownClick(!(dropdownState.isFinanceVo), setDropdownState)
                          }
                          onContextMenu={() =>
                            handleDropdownClick(!(dropdownState.isFinanceVo), setDropdownState)
                          }
                        ></div>
                      )} */}
                      <div
                        className="m-dropdown__wrapper"
                        style={{ zIndex: "101" }}
                      >
                        <span
                          className="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"
                          style={{ left: "auto" }}
                        ></span>
                        <div className="m-dropdown__inner">
                          <div className="m-dropdown__body card-body-sm">
                            <div className="m-dropdown__content">
                              <ul className="m-nav">
                                {/* <c:forEach items="${financialYearVos}" var="financialYearVo"> */}
                                {sessionList?.financialYearVos?.map(
                                  (obj, index) => (
                                    <li key={index} className="m-nav__item">
                                      <a
                                        className="m-nav__link"
                                        onClick={()=>FinancialYearSelector(obj)}
                                      >
                                        <span
                                          className={
                                            sessionList?.financialYear === obj
                                              ? "m-nav__link-text m--font-brand m--font-boldest"
                                              : "m-nav__link-text "
                                          }
                                        >
                                          <i className="fa fa-calendar-o"></i>{" "}
                                          {obj}
                                        </span>
                                      </a>
                                    </li>
                                  )
                                )}

                                {/* </c:forEach> */}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <UserMenuDropDown
                      setDropdownState={setDropdownState}
                      wrapperActive={dropdownState.wrapperActive}
                    />
                    {!sessionList.jioType && (
                      <li className="m-nav__item m-topbar__user-profile  m-dropdown m-dropdown--medium m-dropdown--arrow  m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light quick-actionsbtn">
                        <ShortcutKeyBar
                          isShortCutKey={dropdownState.isShortCutKey}
                          setDropdownState={setDropdownState}
                        />
                      </li>
                    )}

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <spring:eval expression="@environment.getProperty('TYPESENSE_READ_ONLY_API_KEY')" var="typesenseReadOnlyKey" />
        <spring:eval expression="@environment.getProperty('TYPESENSE_URL')" var="typesenseURL" />
        <spring:eval expression="@environment.getProperty('TYPESENSE_PORT')" var="typesensePort" />
        <spring:eval expression="@environment.getProperty('TYPESENSE_PROTOCOL')" var="typesenseProtocol" /> */}
        <input
          type="hidden"
          id="companyId"
          value={sessionList?.companyId}
          style={{ display: "none" }}
        />
        <input
          type="hidden"
          id="merchantTypeId"
          value={sessionList?.merchantTypeId}
          style={{ display: "none" }}
        />
        <input
          type="hidden"
          id="allowTypesense"
          value={sessionList?.allowTypesense}
          style={{ display: "none" }}
        />
      </header>
      <SupportRequestModal open={isSupportModalOpen} onClose={() => {
        setIsSupportModalOpen(false)
      }}/>
    </>
  );
};

export default Header;
